import type { TFeatureFlags } from '@roko/ui/types/common'

import { sleep } from '@/utils/utils'

const TEST_FEATURES: TFeatureFlags = {
  feature2: {
    enabled: true,
  },
}

export async function fetchFeatures(): Promise<TFeatureFlags> {
  await sleep(1000)

  return TEST_FEATURES
}
